import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import sanitizedContentData from '@/components/shared/utils/sanitizedContentData'
import { motion } from 'framer-motion'

// styles
import './styles.ttm.scss'

const ItemTestimonial = ({ data, index }) => {
  const img = get(data, ['img'], null)
  const subTitle = get(data, ['subTitle'], '')
  const title = get(data, ['title'], '')
  const content = get(data, ['content'], '')

  return (
    <motion.div
      style={{
        position: 'relative',
      }}
      key={index}
      transition={{
        duration: 0.6,
        delay: index * 0.3 + 0.3,
      }}
      viewport={{
        once: true,
      }}
      initial={{
        opacity: 0,
        left: '70px',
      }}
      whileInView={{ opacity: 1, left: '0px' }}
      exit={{ opacity: 0 }}
      className="itemTestimonial"
    >
      <img src={img.url} alt={img.alt} />
      <div className="w-full h-auto overflow-auto">
        <h4 title={title}>{title}</h4>
        <pre title={subTitle}>{subTitle}</pre>
      </div>
      <div className="containerParagraph" dangerouslySetInnerHTML={sanitizedContentData(content)} />
    </motion.div>
  )
}

ItemTestimonial.propTypes = {
  index: PropTypes.number,
  data: PropTypes.shape({
    img: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),
}

export default ItemTestimonial
